export const AppConfigModuloObrigacoes = {
	keycloakConfig: {
		devUrl: 'http://localhost:8082/',
		url: 'https://authorization.jcmsystem.com.br/',
		realm: 'Abrapp',
		clientId: 'Obrigacoes',
	},
};
